export class ViewStyles {
  public static readonly messageOverFlowMargin = 5;
  public static readonly bodyWidgetVisibleClass = "widget-is-visible";
  public static readonly iFrameBoxShadowString = "box-shadow: 0 0 35px 0 rgba(0, 0, 0, 0.15);";
  public static readonly mainButtonClosedId = "main_button_close";
  public static readonly mainButtonOpenedId = "main_button_open";
}
